import styled from "styled-components";
import DataTable from 'react-data-table-component';
//modal
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import { RiCloseFill } from "react-icons/ri";
import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';

export const UserContainer = styled.div`
display: flex;
position: absolute;
top: 3.5rem;
flex-direction: column;
width: 100%;
height: 100vh;
align-items: center;

`;
export const FiltrosContainer = styled.div`
display: grid;
gap: 1rem;
grid-auto-rows : auto;
grid-template-columns:repeat(auto-fill,minmax(15 rem,1fr));

`;
export const ModalColumna = styled.div`
display: grid;
gap: 1rem;
grid-auto-rows : auto;
grid-template-columns:repeat(auto-fill,minmax(15 rem,1fr));


`;
export const StyledTable = styled(DataTable)`
    width: 100%;
    height: auto;
`;

export const StyledFloatingButton = styled.div`
position: fixed;
width:60px;
height:60px;
bottom:40px;
right:40px;
`;
export const BotonesTabla = styled.div`
display: flex;
flex-direction: row;


`;

export const styles = (theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },

    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0",
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF",
        },
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1",
        },
    },
});

//modal styles
export const stylesModal = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
      },
      formControl: {
        marginTop: theme.spacing(2),
        minWidth: 120,
      },
      formControlLabel: {
        marginTop: theme.spacing(1),
      },
});

export const DialogTitle = withStyles(stylesModal)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                    size="large">
                    <RiCloseFill />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

export const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);